/*
 * Pilotage de la séquence à 3 plans du hero Somno.
 * Ne gère aucune propriété visuelle directement : ce script se contente de
 * poser data-scene="1|2|3" sur .somno-hero (le crossfade et le cadrage
 * restent entièrement définis dans hero-somno.css.liquid), de basculer
 * .is-visible sur .somno-hero__content pour rejouer l'apparition du texte
 * à chaque passage sur le plan 3, et .is-annotating sur le plan 2 pour
 * rejouer la séquence des annotations AirFlex / NightLock à chaque boucle.
 *
 * Cycle : plan 1 -> plan 2 -> plan 3 -> plan 1 ... en boucle, tant que le
 * hero est visible à l'écran. Toute sortie du viewport arrête la boucle ;
 * tout retour dans le viewport relance proprement depuis le plan 1.
 */
(function () {
  'use strict';

  // Durée d'affichage de chaque plan avant de basculer sur le suivant (ms).
  // Le crossfade (400ms, défini en CSS) se joue pendant la fin de ce délai.
  var SCENE_DURATIONS = [1700, 3700, 5500];

  function initSomnoHero(root) {
    if (!root || root.dataset.heroBound === '1') return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Le CSS affiche déjà le plan 3 (produit + texte) fixe et statique : rien à piloter.
      return;
    }

    var content = root.querySelector('.somno-hero__content');
    var sceneTwo = root.querySelector('.somno-hero__scene[data-scene="2"]');
    var index = 0;
    var advanceTimer = null;

    function setScene(i) {
      index = i;
      root.dataset.scene = String(i + 1);
      if (content) {
        if (i === 2) {
          content.classList.remove('is-visible');
          // Reflow avant de rajouter la classe pour garantir le rejeu de la
          // transition CSS à chaque boucle (sinon le navigateur peut fusionner
          // le retrait/ajout et ne pas ré-animer).
          void content.offsetWidth;
          requestAnimationFrame(function () {
            content.classList.add('is-visible');
          });
        } else {
          content.classList.remove('is-visible');
        }
      }
      if (sceneTwo) {
        if (i === 1) {
          sceneTwo.classList.remove('is-annotating');
          void sceneTwo.offsetWidth;
          requestAnimationFrame(function () {
            sceneTwo.classList.add('is-annotating');
          });
        } else {
          sceneTwo.classList.remove('is-annotating');
        }
      }
    }

    function scheduleNext() {
      clearTimeout(advanceTimer);
      advanceTimer = setTimeout(function () {
        setScene((index + 1) % SCENE_DURATIONS.length);
        scheduleNext();
      }, SCENE_DURATIONS[index]);
    }

    function start() {
      clearTimeout(advanceTimer);
      setScene(0);
      scheduleNext();
    }

    function stop() {
      clearTimeout(advanceTimer);
      advanceTimer = null;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    }, { threshold: 0.15 });

    observer.observe(root);

    root.dataset.heroBound = '1';
    root._somnoHeroCleanup = function () {
      stop();
      observer.disconnect();
      if (content) content.classList.remove('is-visible');
      if (sceneTwo) sceneTwo.classList.remove('is-annotating');
      delete root.dataset.heroBound;
      delete root.dataset.scene;
    };
  }

  function teardownSomnoHero(root) {
    if (root && typeof root._somnoHeroCleanup === 'function') {
      root._somnoHeroCleanup();
    }
  }

  function boot() {
    document.querySelectorAll('.somno-hero').forEach(initSomnoHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Évite d'accumuler plusieurs IntersectionObserver / minuteurs quand
  // l'éditeur de thème Shopify recharge la section (theme editor).
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.somno-hero')
      : null;
    teardownSomnoHero(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.somno-hero')
      : null;
    if (root) initSomnoHero(root);
  });
})();
